export function hexToBuf(hex) {
    if (typeof hex === 'string') {
        return Buffer.from(hex.replace(/^0x/i, ''), 'hex');
    }
    else {
        return Buffer.from(hex);
    }
}
export function bufToHex(buf) {
    const _buf = Buffer.from(buf);
    return _buf.toString('hex');
}
export function equalByteArrays(a, b) {
    let aBuf;
    let bBuf;
    if (typeof a === 'string') {
        aBuf = hexToBuf(a);
    }
    else {
        aBuf = Buffer.from(a);
    }
    if (typeof b === 'string') {
        bBuf = hexToBuf(b);
    }
    else {
        bBuf = Buffer.from(b);
    }
    return aBuf.compare(bBuf) === 0;
}
//# sourceMappingURL=utils.js.map